import React from 'react';
import Modal from '../../artzu-ui/src/Modal';
import Button from '../../artzu-ui/src/Button';
import Icon from '../../artzu-ui/src/Icon';

const ConfirmationModal = ({ open, history, location }) => (
  <Modal open={open}>
    <div id="confirmation-modal" className="verify__confirmation--container">
      <Icon size="5x" name="BlueCheck" />
      <div className="verify__confirmation--text">
        {' '}
        Your Autzu account has been created.
        <br />
        <br />
        Click the button to start the application. You can save and continue later anytime.
      </div>
      <Button
        label="Okay"
        onClick={() => history.push(location.state && location.state.fromProfile ? '/profile' : '/apply')}
      />
    </div>
  </Modal>
);

export default ConfirmationModal;



// WEBPACK FOOTER //
// ./src/components/User/ConfirmationModal.js